type JsonObject = Record<string, unknown>;

export function jsonHeaders(accessKey = "") {
  const headers: Record<string, string> = { "content-type": "application/json" };
  if (accessKey.trim()) headers.authorization = `Bearer ${accessKey.trim()}`;
  return headers;
}

export async function parseJsonResponse(response: Response) {
  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return { ok: response.ok, raw: text };
  }
}

export function messageFromData(data: unknown, fallback: string) {
  if (data && typeof data === "object") {
    const obj = data as JsonObject;
    const detailedError = obj.error || obj.reason;
    const genericMessage = obj.message;
    if (typeof detailedError === "string" && detailedError.trim()) return detailedError;
    if (typeof genericMessage === "string" && genericMessage.trim()) return genericMessage;
    return fallback;
  }
  return fallback;
}
